export function getNodePath(root: Node, target: Node): number[] | null {
  if (root === target) {
    return [];
  }

  const path: number[] = [];
  let current: Node | null = target;

  while (current && current !== root) {
    const parent = current.parentNode as ParentNode;

    if (!parent) {
      return null;
    }

    const index = Array.from(parent.childNodes).indexOf(current as ChildNode);
    if (index === -1) {
      return null;
    }

    path.unshift(index);
    current = parent;
  }

  return current === root ? path : null;
}

export function getNodeByPath(root: Node, path: number[]): Node | null {
  let current: Node = root;

  for (const index of path) {
    if (!current.childNodes[index]) {
      return null;
    }
    current = current.childNodes[index];
  }

  return current;
}

export function createHighlightHtmlFromRange(
  container: HTMLElement,
  range: Range,
  keyId: string,
): string | null {
  const cloned = container.cloneNode(true) as HTMLElement;

  const startPath = getNodePath(container, range.startContainer);
  const endPath = getNodePath(container, range.endContainer);

  if (!startPath || !endPath) {
    console.error('Could not find path to range containers');
    return null;
  }

  const startNode = getNodeByPath(cloned, startPath);
  const endNode = getNodeByPath(cloned, endPath);

  if (!startNode || !endNode) {
    console.error('Could not find nodes by path in cloned container');
    return null;
  }

  try {
    const newRange = document.createRange();
    newRange.setStart(startNode, range.startOffset);
    newRange.setEnd(endNode, range.endOffset);

    const wrapper = document.createElement('span');
    wrapper.setAttribute('data-highlight-keyid', keyId);

    const contents = newRange.extractContents();
    wrapper.appendChild(contents);

    newRange.insertNode(wrapper);

    return cloned.innerHTML;
  } catch (error) {
    console.error('Error creating highlight HTML from range:', error);
    return null;
  }
}

